import { cn } from "@/lib/cn";
import { shimmer, skeletonSurface } from "@/lib/shimmer";

/**
 * Grid of KPI cards. Layout picks 4x1 for count=4, 3x1 for count=3, 2x2
 * for count=4 if it doesn't fit a row, etc. Default count=4.
 */
export function KpiGridSkeleton({
  count = 4,
  className,
}: {
  count?: number;
  className?: string;
}) {
  const cols =
    count >= 4 ? "grid-cols-4" : count === 3 ? "grid-cols-3" : "grid-cols-2";

  return (
    <div
      className={cn("grid gap-3", cols, className)}
      aria-hidden="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <KpiCard key={i} />
      ))}
    </div>
  );
}

function KpiCard() {
  return (
    <div
      className={cn(
        "relative flex flex-col justify-between rounded-[16px] border border-white/5 p-4",
        skeletonSurface,
        shimmer,
      )}
      style={{ height: 96 }}
    >
      {/* Label */}
      <div className="h-3 w-24 rounded bg-white/[0.06]" />
      {/* Value */}
      <div className="mt-2 h-7 w-20 rounded bg-white/[0.08]" />
      {/* Trend */}
      <div className="flex items-center gap-2">
        <div className="h-2 w-2 rounded-full bg-white/[0.08]" />
        <div className="h-2 w-14 rounded bg-white/[0.04]" />
      </div>
    </div>
  );
}
